module.exports = __webpack_public_path__ + "static/media/1section.6c5294fc.png";